/** Calendar-day ranges shared by the Agenda counters and event lists. */
export function agendaEventRange(kind: "today" | "week", now = new Date()) {
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (kind === "today" ? 1 : 7));
  return { start: start.toISOString(), end: end.toISOString() };
}

/** Match the day heading to the device-local time displayed in the row. */
export function localEventDayKey(iso: string) {
  const date = new Date(iso);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
